<div class="toggle-pill-group" role="group">
  <button
    *ngFor="let opt of options"
    type="button"
    class="toggle-pill-group__pill"
    [ngClass]="opt.pendoClass"
    [attr.id]="pillId(opt.value)"
    [class.toggle-pill-group__pill--active]="isActive(opt.value)"
    [attr.aria-pressed]="isActive(opt.value)"
    [disabled]="disabled"
    [matTooltip]="opt.tooltip || ''"
    matTooltipPosition="below"
    (click)="toggle(opt.value)"
  >
    {{ opt.label }}
  </button>
</div>
